import type { FaireProductEntity } from "../../entity_types/product";

export const p_exjnndytdg: FaireProductEntity = {
  token: "p_exjnndytdg",
  type: "product",
  name: "Concentrated Cleaning Tablets (5 Tabs)",
  brandToken: "b_9p9pjx33",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2faba5d657b9a033434826c504b4dc4fbffe9e092686aec2c49b29f9c45f3a8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2da050bdd130cb4a9d37f0d6909b1977046aa7084a88f4b9d9a18cf84fc63583.jpeg",
    "https://cdn.faire.com/fastly/35457cafde26a65c7e68d294da3962bf741af07d638edaa65af6530a905ac610.jpeg",
    "https://cdn.faire.com/fastly/cab49454e1f9a1d3f237bc3d0b106294bc095a719b5096510427cb0c07f9327a.jpeg",
  ],
  priceDollars: 4.85,
  description:
    "Product Details:\n- Create and customize your cleaning products with Multi-Purpose Concentrated Cleaning Tablets + Simply Earth Essential Oils.\n- Know that your home is clean AND safe with our carefully-selected ingredients.\n- Do your part by eliminating plastic in your home.\n- 0.14oz each\n\nYou're going to LOVE how these Multi-Purpose Concentrated Cleaning Tablets clean your home!\nOur Multi-Purpose Concentrated Cleaning Tab will change the way you clean your home! Here's why:\nCleans like a dream - Eliminates plastic - Safe ingredients - SLS free - Customizable with essential oils - Clean your entire home for less than $1/week!\n\nThis Multi-Purpose Concentrated Cleaning Tab will let you take back control of the cleaning in your home!\nIngredients: Sodium Bicarbonate, DL-TARTARIC Acid, Sodium Lauroyl Glutamate, Citric Acid, Sodium Benzoate, Sodium Chloride",
  tags: [],
  msrpDollars: 9.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:35.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
